<div class="body-container">

    <div class="side-bar-container">
        @if (userSession) {
        <app-side-menu></app-side-menu>
        }
    </div>

    <div class="main-container" [ngClass]="{ 'logout': !userSession }">
        <app-loading-global></app-loading-global>
        @if (userSession) {
            <app-toolbar></app-toolbar>
        }
        <div class="table-wrapper">
            <router-outlet></router-outlet>
        </div>
        @if (userSession) {
            <app-footer></app-footer>
        }
    </div>
</div>
